export default "__VITE_ASSET__BsPF0DHu__"